import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import PessoaJuridica from "../../assets/navbar/Pessoa_juridica_on.svg";
import MotivosRejeicao from "../../assets/navbar/Convenios_on.svg";
import LupaOn from "../../assets/navbar/Lupa_on.svg";
import Button from "../../components/Button";
import SkeletonListItem from "../SkeletonListItem";

import api from "../../services/api";
import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import InputMask from "react-input-mask";
import { toast } from "react-toastify";

import { Context } from "../../context/globalContext";
import { mask } from "../../utils/mask";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import BorderForSelectNumberOfRecords from "../BorderForSelectNumberOfRecords";
import BorderForSort from "../BorderForSort";
import { GoTopoButtonWrapper } from "../../styles/commonStyle";
import { IoChevronUp } from "react-icons/io5";
import ButtonV2 from "../Button-v2";
import { size } from "lodash";
import MotivoRejeicao from "../../services/motivos-rejeicao";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function ListMotivosRejeicao({ history, pageFilter, filter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);

  const [motivosRejeicao, setMotivosRejeicao] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const [sortIndex, setSortIndex] = useState(0);

  async function getDataByMotivosRejeicaoFiltered(filter, page) {
    try {
      setIsLoading(true);
      const response = await MotivoRejeicao.listData(filter);
      if (response && (response.status === 201 || response.status === 200)) {
        setMotivosRejeicao(response.data);
        setTotalElements(size(response.data));
      } else if (!response) {
        setMotivosRejeicao([]);
        toast.error("Erro ao buscar os motivos-rejeicao.");
      }

      setIsLoading(false);
    } catch (err) {
      setMotivosRejeicao([]);
      setTotalElements(0);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar os motivos-rejeicao.");
      }
    }
  }

  useEffect(() => {
    if (filter) {
      setSearch(filter);
    }

    loadFiltered(filter);
  }, [filter]);

  async function loadFiltered(filter) {
    getDataByMotivosRejeicaoFiltered(filter);
  }

  const reloadPage = (filter, page) => {
    history.replace(`?filter=${desmaskIfNumber(filter)}`);
  };

  const handleKeyPress = (event) => {
    const value = event.target.value;
    if (event.key === "Enter") {
      reloadPage(value);
    }
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <div className="boxSearch">
            <S.SvgIcon src={LupaOn} className="lupa" />
            <InputMask
              type="text"
              name="search"
              alwaysShowMask={false}
              value={search}
              onKeyPress={(e) => handleKeyPress(e)}
              onChange={(ev) => setSearch(ev.target.value)}
            />
            <Button type="button" onClick={() => reloadPage(search)}>
              Buscar
            </Button>
          </div>
          <S.CardHeader>
            <span>
              {`${totalElements} ${totalElements > 1 ? "" : ""} cadastro${
                totalElements > 1 ? "s" : ""
              } no sistema`}
            </span>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {motivosRejeicao &&
                motivosRejeicao?.map((motivoRejeicao) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() =>
                            history?.push(
                              `/cadastro-motivos-rejeicao/${motivoRejeicao?.codigo}`
                            )
                          }
                        >
                          <S.SvgIcon src={MotivosRejeicao} alt="" />
                          <div className="dataCard">
                            <h4>Código:</h4>
                            <h4>Descrição:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">
                              {motivoRejeicao?.codigo}
                            </h4>
                            <h4 className="h4-info">
                              {motivoRejeicao?.descricao}
                            </h4>
                          </div>
                        </S.Info>
                      </S.Custumer>
                    </>
                  );
                })}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
          <GoTopoButtonWrapper>
            <ButtonV2
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              height="32px"
              leftIcon={IoChevronUp}
            >
              Topo
            </ButtonV2>
          </GoTopoButtonWrapper>
        </S.Card>
      </S.Container>
    </>
  );
}
